import { Loader } from "components/Common/Loader";
import { ShowStatus } from "components/Common/ShowStatus";
import TransactionType from "components/Common/TopupHistory/TransactionType";
import { useEffect, useMemo } from "react";

const DesktopTable = ({
  historyDetailsList,
  headerList,
  loading,
  fetchData,
  businessID,
  hasMoreData,
}: topUpHistoryProps) => {
  useEffect(() => {
    document.body.classList.add("overflow-y-hidden");
    return () => {
      document.body.classList.add("overflow-y-scroll");
    };
  }, []);

  const debitTransactions = useMemo(() => ["PO", "EA"], [historyDetailsList]);

  return (
    <div className="bg-offWhite flex flex-col max-h-[80vh] overflow-auto relative no-scrollbar">
      {/* //Bottom TABLE// */}
      <div className="bg-white list relative">
        <table className="w-full table-auto text-left">
          <thead className="sticky top-0 bg-paleLilac">
            <tr>
              {headerList?.map((head) => (
                <th
                  key={head}
                  className="border-b border-paleGrey p-4"
                >
                  <h2 className="font-poppins font-medium text-sm leading-none tracking-normal text-grayMedium">
                    {head}
                  </h2>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white list-inner">
            {historyDetailsList?.map(
              ({ transactionID, amount, date, status, type }, index) => {
                const isLast = index === historyDetailsList.length - 1;
                const classes = `font-poppins font-normal text-sm leading-none tracking-normal text-darkBlack bg-white ${isLast ? "p-4" : "p-4 border-b border-gray-100"}`;

                return (
                  <tr key={transactionID}>
                    <td className={classes}>{transactionID}</td>
                    <td className={classes}>
                      {debitTransactions.includes(type) ? "-" : ""}${amount}
                    </td>
                    <td className={classes}>{date}</td>
                    <td className={classes}>
                      <TransactionType type={type} />
                    </td>
                    <td className={classes}>
                      <ShowStatus status={status} />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
        {!loading && hasMoreData && (
          <div className="flex  items-center justify-center ">
            <button
              type={"button"}
              onClick={() => {
                fetchData(businessID);
              }}
              disabled={false}
              className={`text-black  w-25  font-medium rounded-lg text-l  py-2.5 px-2 mt-2 mb-2`}
            >
              {" "}
              <div className="flex flex-row gap-2">Load more</div>
            </button>
          </div>
        )}
        {loading && (
          <div className="flex w-full mt-2 mb-2 items-center justify-center">
            <Loader size={6} color="darkBlue" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopTable;
